import {CellProps, Column, Row} from '@komune-io/g2-layout'
import {Typography} from '@mui/material'
import {TFunction} from 'i18next'
import {PlatformTableSearchFilters, PlatformPaginatedTable} from "@tracabois/template";
import {firstPage, OffsetPagination, PageQuery, PageResult} from "@tracabois/utils";
import {BuildingType} from "../../model/BuildingType";

interface BuildingTypeTableProps {
  page?: PageResult<BuildingType>
  isLoading?: boolean
  onPageQueryChange: (page: PageQuery) => void;
  onRowClicked: (row: Row<BuildingType>) => void;
  actions: React.ReactNode
}

export const BuildingTypeTable = (props: BuildingTypeTableProps) => {
  const {page, isLoading, onPageQueryChange, onRowClicked, actions} = props

  const onSearch = (search?: string) => {
    onPageQueryChange({
      pagination: page?.pagination || firstPage,
      search: search
    })
  }
  const filter = (
    <PlatformTableSearchFilters actions={actions} onSubmit={(props) => onSearch(props.search)}/>
  )
  const onPaginationChange = (pagination: OffsetPagination) => {
    onPageQueryChange({
      pagination: pagination,
      search: page?.search
    })
  }
  return (
    <PlatformPaginatedTable<BuildingType>
      page={page}
      columnsDefinition={getColumns}
      isLoading={isLoading}
      actions={filter}
      onPageChange={onPaginationChange}
      onRowClicked={onRowClicked}
      noElevation
    />
  )
}


const getColumns = (t: TFunction): Column<BuildingType>[] => ([{
  Header: `${t("buildingType.name", "Libéllé")}`,
  // @ts-ignore
  Cell: ({row}: CellProps<BuildingType>) => (
    <Typography variant="body2"
    >{row.original.name}</Typography>
  )
}])
